module.exports = __webpack_public_path__ + "img/icone-task.d8fdd94c.svg";